module.exports = __webpack_public_path__ + "static/media/brandon-grotesque-blk-it.e4c1a596.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/brandon-grotesque-blk-it.svg
// module id = 118
// module chunks = 0